module.exports = __webpack_public_path__ + "assets/learnkey-logo-cr-lt.7d44b175.svg";